import React from 'react';
import {
  PriceRow,
  PlanIcon,
  PriceLabel,
  PlanBadge,
  PlanItemContainer
} from '../styles';
import { InkSupplies } from 'src/assets/images';
import { useTranslationWithInterpolation } from 'src/hooks/useTranslationWithValues/useTranslationWithValuesHelper';
import { PrinterItem } from 'src/utils/Products/productFilter';
import { formatPrice } from 'src/utils/Products/getCalculatePriceDifferance';

interface PrinterDetailsProps {
  selectedPrinterDetails?: PrinterItem;
}

const PrinterDetails: React.FC<PrinterDetailsProps> = ({
  selectedPrinterDetails
}) => {
  const { getText, getTextWithValues } = useTranslationWithInterpolation();

  // Get the recommended plan or first plan as fallback
  const selectedPlan =
    selectedPrinterDetails?.inkPlan?.find((plan) => plan.recommendedPlan) ||
    selectedPrinterDetails?.inkPlan?.[0];

  const printer = {
    name: getTextWithValues('planSummary.printer.name', '{{printerModel}}', {
      printerModel: selectedPrinterDetails?.printerName || ''
    }),
    price: getTextWithValues(
      'planSummary.printer.totalPerMonth',
      '{{amount}}/month',
      {
        amount: formatPrice(Math.abs(selectedPlan?.totalPrice || 0))
      }
    ),
    imageUrl: selectedPrinterDetails?.thumbnailImage,
    altText: selectedPrinterDetails?.printerName || ''
  };

  const printPlan = {
    pages: getTextWithValues(
      'planSummary.printPlan.pages',
      'Print plan: {{pages}} pages/month',
      {
        pages: selectedPlan?.pagesPerMonth || 0
      }
    ),
    badge: getText('planSummary.printPlan.badge', 'Included'),
    imageUrl: InkSupplies,
    altText: getText('planSummary.printPlan.altText', 'Ink Supplies')
  };

  return (
    <>
      <PriceRow>
        <PlanItemContainer>
          <PlanIcon>
            <img
              src={printer.imageUrl}
              alt={printer.altText}
            />
          </PlanIcon>
          <PriceLabel>{printer.name}</PriceLabel>
        </PlanItemContainer>
        <PriceLabel>{printer.price}</PriceLabel>
      </PriceRow>

      <PriceRow>
        <PlanItemContainer>
          <PlanIcon>
            <img
              src={printPlan.imageUrl}
              alt={printPlan.altText}
            />
          </PlanIcon>
          <PriceLabel>{printPlan.pages}</PriceLabel>
        </PlanItemContainer>
        <PlanBadge>{printPlan.badge}</PlanBadge>
      </PriceRow>
    </>
  );
};

export default PrinterDetails;
